import React from 'react'
import { MenuItem, TextField } from '@mui/material'
import styled from 'styled-components'
import find from 'lodash/find'
import { withTranslator } from '../../HOCComponents/withTranslator'
import { DASHBOARD_FILTERS_TYPES } from '../../../actions/dashboard'

const { FLIGHT_SATELLITE, FLIGHT_DRONE } = DASHBOARD_FILTERS_TYPES

const SOURCES = [
  { id: FLIGHT_SATELLITE, label: 'satélite', icon: 'fa-solid fa-satellite' },
  { id: FLIGHT_DRONE, label: 'dron', icon: 'flaticon-drone' }
]

const SourceIcon = styled.i`
  width: 20px;
  margin-right: 8px;
  font-size: 16px;
  text-align: center;
`

const selectSx = {
  minWidth: 130,
  '& .MuiSelect-select': {
    display: 'flex',
    alignItems: 'center'
  }
}

const SourceOption = ({ t, source }) => (
  <>
    <SourceIcon className={source.icon} />
    {t(source.label)}
  </>
)

// Satellite and drone are mutually exclusive (the reducer always keeps exactly one on), so a single select shows the active one.
function FlightSourceSelect({ t, value, onChange }) {
  return (
    <TextField
      select
      label={t('source')}
      value={value}
      onChange={event => onChange(event.target.value)}
      SelectProps={{ renderValue: selected => <SourceOption t={t} source={find(SOURCES, { id: selected })} /> }}
      sx={selectSx}
      data-testid="dashboard-source-select"
    >
      {SOURCES.map(source => (
        <MenuItem key={source.id} value={source.id} data-testid={`dashboard-source-${source.id}`}>
          <SourceOption t={t} source={source} />
        </MenuItem>
      ))}
    </TextField>
  )
}

export default withTranslator(FlightSourceSelect)
